import { Variable } from '~/packages/variable/variables.typing'
import { defineAction, number, object, string } from '~/prix'
import expression from '~/prix/types/expression'
import { analysis } from '~/prix/types/presets/analysis'
import { assertions } from '~/prix/types/presets/assertions'
import { select } from '~/prix/types/presets/select'
import { childrenType, spaceForPoint } from '~/prix/types/presets/space'
import { timeForIncidence } from '~/prix/types/presets/time'
import { variable } from '~/prix/types/presets/variable'
import { pick } from '~/prix/utils/types/object'
import getRecommendedCacheOptions from '~/utils/server/stats/getRecommendedCacheOptions'
import {
  appSebraeAttendanceExpression,
  appSebraeAttendanceVariable,
} from '../../stats/appSebraeAttendanceStats.definition'
import appSebraeAttendanceMedianPerDayAction from './appSebraeAttendanceMedianStats.action.json' with { type: 'json' }

const appSebraeAttendanceMedianPerDayExpression = expression(
  pick(appSebraeAttendanceExpression.shape, [
    'size',
    'ageGroup',
    'segmentId',
    'registrationStatus',
    'agentCpf',
  ]),
)

export const appSebraeAttendanceMedianPerDayVariable: Variable = {
  ...appSebraeAttendanceVariable,
  key: 'appSebraeAttendanceMedianPerDay',
  categoryKey: appSebraeAttendanceVariable.categoryKey,
  categoryKeys: appSebraeAttendanceVariable.categoryKeys,
  actionDefinitionKey: appSebraeAttendanceMedianPerDayAction.key,
  presetKey: 'appSebraeAttendanceMedianPerDay',
  title: 'Mediana de atendimentos por agente',
  label: 'Produtividade diária dos agentes',
  description:
    'Mediana de atendimentos realizados por agente em dias trabalhados, usando o endereço cadastral da Receita Federal do Brasil para localização.',
  aggregationMode: 'median',
  filterableBy: appSebraeAttendanceMedianPerDayExpression,
  compatibleChildrenTypes: ['country', 'macroRegion', 'state', 'mesoRegion', 'microRegion', 'city'],
}

const appSebraeAttendanceMedianPerDayDefinition = defineAction({
  ...appSebraeAttendanceMedianPerDayAction,
  input: object({
    variable,
    highlight: appSebraeAttendanceMedianPerDayExpression.isOptional(),
    filter: appSebraeAttendanceMedianPerDayExpression.isOptional(),
    space: spaceForPoint().isOptional(),
    time: timeForIncidence().isOptional(),
    select: select(appSebraeAttendanceVariable.shape!),
    assertions,
    analysis,
  }),
  output: object({
    items: object({
      value: number(),
      numerator: number().isOptional(),
      denominator: number().isOptional(),
      geoId: string().isOptional(),
      geoType: childrenType.isOptional(),
      dateTime: string().isOptional(),
    }),
  }),
  cache: getRecommendedCacheOptions,
})

export default appSebraeAttendanceMedianPerDayDefinition
